import React from 'react';
import { NavLink } from 'react-router-dom';
import styleNavbar from './navbar.module.css';

const linkClass = ({ isActive }) =>
	`${styleNavbar.navlink}${isActive ? ` ${styleNavbar.selected}` : ''}`;

const Navbar = () => {
	return (
		<nav className={styleNavbar.container}>
			<NavLink to="/videos" className={linkClass}>
				Videos
			</NavLink>
			<NavLink to="/sounds" className={linkClass}>
				Sounds
			</NavLink>
			<NavLink to="/impressions" className={linkClass}>
				Impressions
			</NavLink>
		</nav>
	);
};
export default Navbar;
